"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useChangeRoutes = void 0;
var react_1 = __importDefault(require("react"));
// import { condWeb } from './WebRoute/condWeb';
// import { locationPath } from './WebRoute/useUrlHistory/locationPath';
var useChangeRoutes = function (info) {
    // ----------- set Hooks
    var _a = react_1["default"].useState(''), sttSelected = _a[0], setSelected = _a[1];
    // ----------- set Action
    var setRouteData = function (path) {
        // ----------- try not Repeat Changes (error to reload web pages)
        // if (condWeb()) {
        //   const noCall = path === locationPath();
        //   if (noCall) return;
        // }
        // ----------- call Set Change
        setSelected(path);
        // ----------- call Change Data
        info.getData(path);
    };
    // ----------- set Return
    return { sttSelected: sttSelected, setRouteData: setRouteData };
};
exports.useChangeRoutes = useChangeRoutes;
